import { TabsBarTab } from '../../../Elements/Tabs/TabsBar'
import { HeaderContext } from '../context'
import React, { useCallback } from 'react'

interface UseProviderTabsHook {
  tabs: TabsBarTab[]
  setTabs: (value: TabsBarTab[]) => void
  activeTab: number
  setActiveTab: (value: number) => void
}

/**
 * hook to manage tabs displayed inside header component
 * @returns tabs and necessary setters
 */
export const useHeaderTabs = (): UseProviderTabsHook => {
  const contextValue = React.useContext(HeaderContext)

  if (contextValue === undefined) {
    throw new Error('useHeaderTabs must be used within HeaderProvider')
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setHeaderTabs = useCallback((value: TabsBarTab[]): void => contextValue.setTabs(value), [contextValue.setTabs])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setActiveTab = useCallback((value: number): void => contextValue.setActiveTab(value), [contextValue.setActiveTab])

  return { tabs: contextValue.tabs, setTabs: setHeaderTabs, activeTab: contextValue.activeTab, setActiveTab }
}
